import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface MarkdownTextProps {
  value?: string | null;
  emptyText?: string;
  inline?: boolean;
}

// Renders **bold** and preserves newlines as <br/>. Nothing else.
// Text-only output (no dangerouslySetInnerHTML), so user input is XSS-safe.
const renderLine = (line: string, key: number): React.ReactNode => {
  const nodes: React.ReactNode[] = [];
  const regex = /\*\*([^*]+)\*\*/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let i = 0;

  while ((match = regex.exec(line)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(line.slice(lastIndex, match.index));
    }
    nodes.push(<strong key={`b-${key}-${i++}`}>{match[1]}</strong>);
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < line.length) {
    nodes.push(line.slice(lastIndex));
  }
  return <React.Fragment key={key}>{nodes}</React.Fragment>;
};

const MarkdownText: React.FC<MarkdownTextProps> = ({
  value,
  emptyText = '-',
  inline = false,
}) => {
  if (!value || !value.trim()) {
    return <Text type="secondary">{emptyText}</Text>;
  }

  const lines = value.split('\n');
  const nodes: React.ReactNode[] = [];
  lines.forEach((line, idx) => {
    nodes.push(renderLine(line, idx));
    if (idx < lines.length - 1) {
      nodes.push(<br key={`br-${idx}`} />);
    }
  });

  if (inline) return <>{nodes}</>;
  return <div style={{ whiteSpace: 'normal' }}>{nodes}</div>;
};

export default MarkdownText;
